/**
 * @module app.core
 */

import { autoinject, bindingMode } from 'aurelia-framework';
import { ComponentBase, IForm } from 'app/shared/lib/essette-site';
import { bindable } from 'aurelia-typed-observable-plugin';
import { MemberService } from 'app/cd/services/member-service';
import { apiCall } from 'app/shared/lib/essette-api';
import { Toaster } from 'app/shared/lib/toaster';
import { I18N } from 'aurelia-i18n';
import * as CD from 'app/cd/models/essette-api';

@autoinject()
export class SaveCondition extends ComponentBase implements IForm {

  ////****************** Fields and Properties ************************************////
  @bindable({ defaultBindingMode: bindingMode.toView })
  protected memberPlanId: string = "";

  @bindable({ defaultBindingMode: bindingMode.toView })
  protected conditions: ReadonlyArray<CD.Condition> = [];

  public memberCondition: CD.MemberCondition | null | undefined = null;
  public condition: CD.Condition | null | undefined = null;
  public conditionStart: string | null | undefined = '';
  public conditionEnd: string | null | undefined = '';

  ////****************** Lifecycle events (in order of execution) *****************////
  constructor(
    private readonly memberService: MemberService,
    private readonly toaster: Toaster,
    private readonly i18n: I18N,
    ...rest: any[]) {
    super(...rest);
  }

  ////****************** Events ***************************************************////

  ////****************** Functions ************************************************////
  protected buildMemberCondition(): CD.MemberCondition {
    const memberCondition: CD.MemberCondition = {
      "id": this.memberCondition?.id,
      "member": {
        "plan": {
          "id": this.memberPlanId
        }
      },
      "condition": {
        "id": this.condition?.id
      },
      "dateRange": {
        "start": this.conditionStart,
        "end": this.conditionEnd
      },
      "isActive": true
    };

    return memberCondition;
  }

  ////****************** IForm ****************************************************////
  public hasChanges(): boolean {
    throw new Error('Method not implemented.');
  }

  public async submit(): Promise<boolean> {
    const memberCondition: CD.MemberCondition = this.buildMemberCondition();
    const isSuccessful = await this.saveCondition(memberCondition);
    return isSuccessful;
  }

  ////****************** Service Calls ********************************************////
  @apiCall
  protected async saveCondition(memberCondition: CD.MemberCondition): Promise<boolean> {
    if(!memberCondition.member?.plan?.id || !memberCondition.condition?.id || !memberCondition.dateRange?.start) { return false; }

    let isSuccessful = false;
    let errorMessage: string = "";
    let duplicateRecord: boolean = false;

    try {
      this.state.beginSave();
      const response = await this.memberService.saveMemberCondition(memberCondition);
      isSuccessful = response.isSuccessful;

      return isSuccessful;
    }
    catch(error) {
      if(error.description) { errorMessage = error.description; }
      duplicateRecord = error.status.errors.some((err: any) => err.code === 'property.constraintViolated');
      throw error;
    }
    finally {
      if(isSuccessful) {
        if(memberCondition.id) {
          this.toaster.standard.updated('cd:condition.$', isSuccessful);
        } else {
          this.toaster.standard.created('cd:condition.$', isSuccessful);
        }
      } else {
        if(duplicateRecord) {
          if(memberCondition.id) {
            this.toaster.error().message(this.i18n.tr('ui:messages.duplicate.update_error', { what: this.i18n.tr('cd:provider.startDate.$'), item: this.i18n.tr('cd:condition.$') })).show();
          } else {
            this.toaster.error().message(this.i18n.tr('ui:messages.duplicate.create_error', { what: this.i18n.tr('cd:provider.startDate.$'), item: this.i18n.tr('cd:condition.$') })).show();
          }
        } else {
          const exception = (this.toaster.toast())
            .title('Error')
            .class('ess-toast-error')
            .icon('ui:icons.error')
            .message(errorMessage)
          exception.show();
        }
      }
      this.state.endSave();
    }
  }
}
